/* eslint-disable max-len */
import mediumBoxesImage from 'assets/images/landing/moving-supplies/medium-boxes.jpg';
import wardrobeBoxesImage from 'assets/images/landing/moving-supplies/wardrobe-boxes.jpg';
import kitchenBoxesImage from 'assets/images/landing/moving-supplies/kitchen-boxes.jpg';
import bubbleWrapImage from 'assets/images/landing/moving-supplies/bubble-wrap.jpg';
import mattressCoversImage from 'assets/images/landing/moving-supplies/mattress-covers.jpg';
import officeAndFileImage from 'assets/images/landing/moving-supplies/office-and-file-boxes.jpg';
import tapeImage from 'assets/images/landing/moving-supplies/tape.jpg';
import mirrorBoxImage from 'assets/images/landing/moving-supplies/mirror-box.jpg';
import xpaperPadsImage from 'assets/images/landing/moving-supplies/xpaper-pads-2a.jpg';
import movingLabelsImage from 'assets/images/landing/moving-supplies/moving-labels.jpg';
import movingBlanketsImage from 'assets/images/landing/moving-supplies/moving-blankets.jpg';
import tvBoxesImage from 'assets/images/landing/moving-supplies/tv-boxes.jpg';

const StaticCardData = [
	{
		title: 'Moving boxes',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dboxes%2Fmedium%2Dboxes&afftrack=',
		text: 'Standard moving boxes for moving, storing or packing.',
		image: mediumBoxesImage
	},
	{
		title: 'Wardrobe moving boxes',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dboxes%2Fwardrobe%2Dboxes&afftrack=',
		text: 'Keep your clothes on hangers and wrinkle-free during the move.',
		image: wardrobeBoxesImage
	},
	{
		title: 'Kitchen boxes',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dboxes%2Fkitchen%2Dboxes&afftrack=',
		text: 'Specialty boxes designed to store all of your kitchen essentials and glassware.',
		image: kitchenBoxesImage
	},
	{
		title: 'Bubble wrap / roll',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dsupplies%2Fbubble%2Dwrap%2Fsmall%2Drolls&afftrack=',
		text: 'Protect your fragile items from damage while moving.',
		image: bubbleWrapImage
	},
	{
		title: 'Mattress bags / covers',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dsupplies%2Fmattress%2Dcovers&afftrack=',
		text: 'Need to move or store your mattress? Protect your mattress and box spring from dust, dirt and water with mattress bags and covers.',
		image: mattressCoversImage
	},
	{
		title: 'Office & file boxes',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dboxes%2Foffice%2Dfile%2Dboxes&afftrack=',
		text: 'Lidded, stackable boxes for your office files, papers and other desk items.',
		image: officeAndFileImage
	},
	{
		title: 'Room packing tape',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dsupplies%2Fpacking%2Dtape&afftrack=',
		text: 'Keep your boxes organized by room with labeling tape.',
		image: tapeImage
	},
	{
		title: 'Picture / Mirror boxes',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dboxes%2Fpicture%2Dmirror%2Dboxes&afftrack=',
		text: 'Specialty boxes designed to keep your wall art, mirrors and pictures safe.',
		image: mirrorBoxImage
	},
	{
		title: 'Ultra Paper Pads',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dsupplies%2Fmoving%2Dblankets&afftrack=',
		text: 'Protect your furniture, framed pictures and small appliances from dust, dirt and scratches.',
		image: xpaperPadsImage
	},
	{
		title: 'Moving Labels',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dsupplies%2Fother&afftrack=',
		text: 'Box labels for every room in your home.',
		image: movingLabelsImage
	},
	{
		title: 'Moving Blankets',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dsupplies%2Fmoving%2Dblankets&afftrack=',
		text: 'Wrap and protect your furniture, appliances and other large items from scratches and nicks with moving blankets.',
		image: movingBlanketsImage
	},
	{
		title: 'TV Boxes',
		link: 'https://shareasale.com/r.cfm?b=883129&u=3346460&m=66601&urllink=www%2Eboxengine%2Ecom%2Fmoving%2Dboxes%2Ftv%2Dboxes&afftrack=',
		text: 'Protect your TV for moving and storage in these sturdy, heavy-duty boxes.',
		image: tvBoxesImage
	}
];

export default StaticCardData;
